import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AnalysingContainer = styled.div`
  width: 100%;
  max-width: 500px;
`

export const FileItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${Spacing.S8};
  width: 100%;
  padding: ${Spacing.S8};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.White};
`

export const FileIconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  padding: ${Spacing.S6};
`

export const FileContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${Spacing.S4};
  min-width: 0;
  padding: ${Spacing.S6} ${Spacing.S8};
`

export const SuccessSquircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${BorderRadius.R14};
  background-color: ${Color.Lime100};
`
